import * as React from "react";
const SvgBoxIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path stroke="#fff" d="M.5.5h6v6h-6zM.5 9.5h6v6h-6zM9.5.5h6v6h-6zM9.5 9.5h6v6h-6z" /></svg>;
export { SvgBoxIcon as ReactComponent };